export type ScheduledTask = () => void;

export class Scheduler {
  private handles = new Set<number>();

  schedule(delayMs: number, task: ScheduledTask): number {
    const handle = window.setTimeout(() => {
      this.handles.delete(handle);
      task();
    }, delayMs);
    this.handles.add(handle);

    return handle;
  }

  cancelAll(): void {
    for (const handle of this.handles) {
      window.clearTimeout(handle);
    }

    this.handles.clear();
  }
}

export function scheduleGraceNote(
  scheduler: Scheduler,
  delayMs: number,
  playGraceNote: ScheduledTask
): number {
  return scheduler.schedule(delayMs, playGraceNote);
}
